import { Injectable } from '@angular/core';
import { INDRAApiService } from './api.indra.service';
import { INDRATravelDoc } from '@ibe.models/pax.indra.model.lib';
import { Observable } from 'rxjs';
import { URL_ROOT } from '@ibe.config';

@Injectable({
  providedIn: 'root'
})
export class PassengerApisService {

	constructor(
		private apiService: INDRAApiService
	) { }

	public savePassengerDocument(data: INDRATravelDoc, pnr: string, passenger_id: number): Observable<any> {
		const URL = `${URL_ROOT}booking/pnrs/${pnr}/passengers/${passenger_id}/apis/update`;
		return this.apiService.INDRA_put(URL, data);
	}
}
